export interface Organization {
    id: number;
    billing_address?: any;
    name: string;
    trial_ends_on: Date | null;
}
